module.exports = __webpack_public_path__ + "static/sprite2-eda7fb8fd3cd7c23cc527e53ea04e5b3.webp";